import { render, staticRenderFns } from "./ScoutMessageTemplate.vue?vue&type=template&id=4c69206a&"
import script from "./ScoutMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./ScoutMessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports